var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import ReactPlayer from "react-player/file";
import { createMachine, assign } from "xstate";
import { useInterpret, useActor } from "@xstate/react";
var defaultContext = {
    id: "",
    url: "",
    title: "",
    artist: "",
    currentTime: 0,
    duration: 0,
    playing: false,
};
var playerMachine = 
/** @xstate-layout N4IgpgJg5mDOIC5QAoC2BDAxgCwJYDswBKAOlgBcB7AB2sgGJqAbdATwG0AGAXUVGsqxc5XJXx8QAD0QAWGQHYSMgIydlADgBMATnkBWVduUyANCFaJl8xXvXzNO7TIDM89a4C+Hs2ix5CpMxsBFD0AK7UEOjkYAAiYQBO0aL4XLxIIAJCImIS0ggAbKokegYyBQVOmgq6ZhYI1YrKBc7Kyk56MmqaBTJePhg4BMQkQawhjOhhsGBpElnCKXmy7iTqBeqdes7OavLa2nWIBnokVu4FnJqcuzJa-SC+QwGjLOP4oRQ0cxkLOeIZfJyRQqNRaXQGThGUzmRDqZRKTYFazaTraDbOB5PfwjMYTCJRGIAYUSCTA+HIABVcKhZjx5oJFrlAcd0SROFpOPIZHptFoDIdYQhlAZ2UU9MjygL7FjBjjAm8JjMwABrH78Rn-ZYIfYFEjOUoGZSaY3yXbOI4IZzaTQkZE9dR8zgFPSadSyvzDQJTGYQeiYMQifBhOnpDXZJYs4XqGR29TxjQSzR6NQWoXOFwkJxdZTOTTyIq5l0e564n0ML7UdWZTWR0D5DSxjYJpHJ1OWuxi+y9ZzrCU3PreR5yr2jct+5Vq+m-WvM+uWGNxltJlO5y0tU421oKWw6V2YofY0fUceMN7Vv51qQLpvx+Gt1dp+rW2MuA3xm68k3uw8jl6TiYAwpAgQwvWcAXnHU2QNUo2hNfNzUtDNbQ0XYYwKE1milEt5TIMBVSVfCpzDGsIzna8EG0PMSDbeROF3ZwXTaJCeXZPM2iNGM3BuLwh3wSgIDgCQjwCBkyIgiiAFoCktaScNHSs6AgMSmQk-I83UfVLnkVRE16GF6jaTh9TNHpNEY-NTO0eSXjxD4VK1KNelteNOnsVQrjcTQWM0npym0NQKmqCobLLaZIAcq8gW8oVjVjG5em2JwqILNRQtIAD7JncTtS3dk3UqdoigcGShS6YzXWaXkeQQqFeI8IA */
createMachine({
    context: defaultContext,
    initial: "stopped",
    tsTypes: {},
    schema: {
        context: {},
        events: {},
    },
    states: {
        stopped: {
            on: {
                play: {
                    target: "playing",
                    actions: ["setFile"],
                },
            },
        },
        playing: {
            on: {
                updateDuration: {
                    target: "playing",
                    actions: ["updateDuration"],
                },
                pause: {
                    target: "paused",
                    actions: [],
                },
                stop: {
                    target: "stopped",
                    actions: ["removeFile"],
                },
                updateCurrentTime: {
                    target: "playing",
                    internal: true,
                    actions: ["updateCurrentTime"],
                },
                seek: "seeking",
                play: {
                    target: "playing",
                    actions: ["setFile"],
                },
            },
        },
        paused: {
            on: {
                continue: { target: "playing" },
                stop: {
                    target: "stopped",
                    actions: ["removeFile"],
                },
                seek: "seeking",
                play: {
                    target: "playing",
                    actions: ["setFile"],
                },
            },
        },
        seeking: {
            on: {
                continue: { target: "playing" },
                seek: {
                    target: "seeking",
                    internal: true,
                },
            },
        },
    },
}, {
    actions: {
        updateDuration: assign(function (context, event) { return ({
            duration: event.duration,
        }); }),
        updateCurrentTime: assign(function (context, event) { return ({
            currentTime: event.currentTime,
        }); }),
        setFile: assign(function (context, event) { return ({
            id: event.data.id,
            url: event.data.url,
            artist: event.data.artist,
            title: event.data.title,
        }); }),
        removeFile: assign(function (context, event) { return ({
            id: defaultContext.url,
            url: defaultContext.url,
            artist: defaultContext.artist,
            title: defaultContext.title,
            duration: defaultContext.duration,
            currentTime: defaultContext.currentTime,
        }); }),
    },
});
var Provider = function (_a) {
    var children = _a.children;
    var playerService = useInterpret(playerMachine, {
        devTools: true,
    });
    return (_jsxs(Context.Provider, __assign({ value: { playerService: playerService, selectors: selectors } }, { children: [_jsx(AudioPlayer, {}), children] })));
};
var AudioPlayer = function () {
    var services = React.useContext(Context);
    var state = useActor(services.playerService)[0];
    return (_jsx(_Fragment, { children: state.matches("playing") || state.matches("paused") ? (
        // @ts-expect-error
        _jsx(ReactPlayer, { height: 0, url: state.context.url, playing: state.matches("playing"), progressInterval: 100, onDuration: function (duration) {
                services.playerService.send({
                    type: "updateDuration",
                    duration: duration * 1000,
                });
            }, onProgress: function (_a) {
                var playedSeconds = _a.playedSeconds;
                services.playerService.send({
                    type: "updateCurrentTime",
                    currentTime: playedSeconds * 1000,
                });
            }, onEnded: function () { return services.playerService.send({ type: "stop" }); } })) : null }));
};
var selectors = {
    // @ts-expect-error
    selectId: function (state) { return state.context.id; },
    // @ts-expect-error
    selectArtist: function (state) { return state.context.artist; },
    // @ts-expect-error
    selectTitle: function (state) { return state.context.title; },
    // @ts-expect-error
    selectCurrentTime: function (state) { return state.context.currentTime; },
    // @ts-expect-error
    selectDuration: function (state) { return state.context.duration; },
    // @ts-expect-error
    isInActivePlayerState: function (state) { return ["playing", "paused"].some(state.matches); },
    // @ts-expect-error
    isInPlayingState: function (state) { return ["playing"].some(state.matches); },
};
var Context = React.createContext({
    playerService: {},
    selectors: selectors,
});
export { Context, Provider, selectors };
//# sourceMappingURL=AudioPlayerContext.js.map